// Actions
export const DISPUTE__GET_DISPUTABLE_SCHEDULE_EVENTS = 'DISPUTE__GET_DISPUTABLE_SCHEDULE_EVENTS';
export const DISPUTE__OPEN_SUPPORT_TICKET = 'DISPUTE__OPEN_SUPPORT_TICKET';
export const DISPUTE__SUBMIT_DISPUTE = 'DISPUTE__SUBMIT_DISPUTE';
export const DISPUTE__REQUEST_FIX_OR_CREDIT = 'DISPUTE__REQUEST_FIX_OR_CREDIT';
export const DISPUTES_REDISTRIBUTE = 'DISPUTES_REDISTRIBUTE';
export const DISPUTE__GET_RELEVANT_SCHEDULES = 'DISPUTE__GET_RELEVANT_SCHEDULES';
export const DISPUTE__REPORT_EARLY_COMPLETION = 'DISPUTE__REPORT_EARLY_COMPLETION';
export const DISPUTE__SWITCH_CREW = 'DISPUTE__SWITCH_CREW';
export const DISPUTE__INITIALIZE_CURRENT_DISPUTE = 'DISPUTE__INITIALIZE_CURRENT_DISPUTE';
export const DISPUTE__GOTO_INITIAL_STEP = 'DISPUTE__GOTO_INITIAL_STEP';
export const DISPUTE__GOTO_RESOLUTION_STEP = 'DISPUTE__GOTO_RESOLUTION_STEP';
export const DISPUTE__UPDATE_CURRENT_DISPUTE = 'DISPUTE__UPDATE_CURRENT_DISPUTE';
export const DISPUTE__DECLINE_FIX = 'DISPUTE__DECLINE_FIX';
// Getters
export const DISPUTE__PROPERTIES_WITH_DISPUTABLE_SCHEDULE_EVENTS =
  'DISPUTE__PROPERTIES_WITH_DISPUTABLE_SCHEDULE_EVENTS';
// Mutations
export const DISPUTE__RESET = 'DISPUTE__RESET';
export const DISPUTE__MUTATE_LOADING_STATUS = 'DISPUTE__MUTATE_LOADING_STATUS';
export const DISPUTE__MUTATE_DISPUTABLE_SCHEDULE_EVENTS =
  'DISPUTE__MUTATE_DISPUTABLE_SCHEDULE_EVENTS';
export const DISPUTE__MUTATE_RELEVANT_SCHEDULES = 'DISPUTE__MUTATE_RELEVANT_SCHEDULES';
export const DISPUTE__MUTATE_CURRENT_DISPUTE = 'DISPUTE__MUTATE_CURRENT_DISPUTE';
